import { Routes } from '@angular/router';
import { authGuard } from '../../guards/auth.guard';
import { steuernGuard } from '../../guards/steuern.guard';
import { steuernStepOrderGuard } from '../../guards/steuern-step-order.guard';

export const STEUERN_ROUTES: Routes = [
  {
    path: 'steuern/overview',
    loadComponent: () =>
      import('./module-overview/module-overview.page').then(
        (m) => m.SteuernModuleOverviewPage
      ),
    canActivate: [authGuard, steuernGuard, steuernStepOrderGuard],
  },
  {
    path: 'steuern/personal-information',
    loadComponent: () =>
      import('./personal-information/personal-information.page').then(
        (m) => m.PersonalInformationPage
      ),
    canActivate: [authGuard, steuernGuard, steuernStepOrderGuard],
  },
  {
    path: 'steuern/income',
    loadComponent: () =>
      import('./income/income.page').then((m) => m.IncomePage),
    canActivate: [authGuard, steuernGuard, steuernStepOrderGuard],
  },
  {
    path: 'steuern/assets',
    loadComponent: () =>
      import('./assets/assets.page').then((m) => m.AssetsPage),
    canActivate: [authGuard, steuernGuard, steuernStepOrderGuard],
  },
  {
    path: 'steuern/health',
    loadComponent: () =>
      import('./health/health.page').then((m) => m.HealthPage),
    canActivate: [authGuard, steuernGuard, steuernStepOrderGuard],
  },
  {
    path: 'steuern/other',
    loadComponent: () =>
      import('./other/other.page').then((m) => m.OtherPage),
    canActivate: [authGuard, steuernGuard, steuernStepOrderGuard],
  },
  {
    path: 'steuern/missing-documents-upload',
    loadComponent: () =>
      import('./missing-documents-upload/missing-documents-upload.page').then(
        (m) => m.MissingDocumentsUploadPage
      ),
    canActivate: [authGuard, steuernGuard, steuernStepOrderGuard],
  },
  {
    path: 'steuern/document-review',
    loadComponent: () =>
      import('./document-review/document-review.page').then(
        (m) => m.DocumentReviewPage
      ),
    canActivate: [authGuard, steuernGuard, steuernStepOrderGuard],
  },
  {
    path: 'steuern/extraction',
    loadComponent: () =>
      import('./extraction/extraction.page').then((m) => m.ExtractionPage),
    canActivate: [authGuard],
  },
  {
    path: 'steuern/extractaion',
    redirectTo: 'steuern/extraction',
    pathMatch: 'full',
  },
  {
    path: 'steuern',
    loadComponent: () =>
      import('./steuern.page').then((m) => m.SteuernPage),
    canActivate: [authGuard],
  },
];
